import * as yup from "yup";

export const ConnectZohoValidationSchema = yup.object().shape({
  organization: yup.string().required("Organization is required"),
});
